import { createBrandLogoUtil } from '@Core/lib/tasks/utils/brandLogo';
import { castUtils } from '@Core/lib/tasks/utils/cast';
import { clipboardUtils } from '@Core/lib/tasks/utils/clipboard';
import { confettiUtils } from '@Core/lib/tasks/utils/confetti';
import { dateUtils } from '@Core/lib/tasks/utils/date';
import { fileUrl } from '@Core/lib/tasks/utils/file';
import { guardUtils } from '@Core/lib/tasks/utils/guard';
import { locationUtils } from '@Core/lib/tasks/utils/location';
import { createMoneyUtils } from '@Core/lib/tasks/utils/money';
import { notifyUtils } from '@Core/lib/tasks/utils/notify';
import { numberUtils } from '@Core/lib/tasks/utils/number';
import { createPageUtils } from '@Core/lib/tasks/utils/page';
import { textUtils } from '@Core/lib/tasks/utils/text';
import { createTimeUtils } from '@Core/lib/tasks/utils/time';
import { createTimezoneUtils } from '@Core/lib/tasks/utils/timezone';
import { createWorkflowUtils } from '@Core/lib/tasks/utils/workflow';
import { cn } from '@Pages/pageRuntime/lib/utils';
import { apiErrorUtils } from '@Pages/pageRuntime/sdk/apiErrors';
import type { SdkUtils } from '@Pages/pageRuntime/sdk/types';

import { createDisplayUtils } from './display';
import { phoneUtils } from './phone';
import { pluralize } from './pluralize';
import { tiptapUtils } from './tiptap';
import type { UtilsContext } from './types';

export function createUtils(context: UtilsContext): SdkUtils {
  return {
    cn,
    pluralize,
    workflow: createWorkflowUtils(context.workflowRouteSettings, context.workflowSlugIndex),
    page: createPageUtils(context.pageRouteSettings, context.router),
    file: fileUrl,
    brandLogo: createBrandLogoUtil(context.workspaceFields),
    // Workspace field values are exposed only via `Sdk.workspace.values` — the
    // `utils.workspace` accessor is intentionally not wired into the page SDK.
    // `money` still reads `workspaceFields` for its workspace-currency fallback.
    money: createMoneyUtils(context.workspaceFields),
    cast: castUtils,
    location: locationUtils,
    phone: phoneUtils,
    number: numberUtils,
    date: dateUtils,
    time: createTimeUtils(context.workspaceFields),
    timezone: createTimezoneUtils(context.workspaceFields),
    tiptap: tiptapUtils,
    text: textUtils,
    clipboard: clipboardUtils,
    confetti: confettiUtils,
    notify: notifyUtils,
    guard: guardUtils,
    display: createDisplayUtils(),
    error: apiErrorUtils
  };
}
